import { ITariff } from "@interfaces/admin/tariff";
import { authApi } from "@RTKQuery/basic";

const walletAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAdminWallet: build.query<{
            usdt_wallet: string
        }, void>({
            query: () => "wallet",
        }),
        updateAdminWallet: build.mutation<{
            usdt_wallet: string
        }, {
            usdt_wallet: string
        }>({
            query: (body) => ({
                url: "wallet",
                method: "POST",
                body
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    dispatch(walletAuthApi.util.upsertQueryData("getAdminWallet", undefined, data))
                } catch { }
            },
        })
    }),
    overrideExisting: false,
})

export const {
    useGetAdminWalletQuery,
    useUpdateAdminWalletMutation
} = walletAuthApi;